import { isAfter, parseISO } from "date-fns";

export default (dates: string[]): Date | null => {
  if (dates.length === 0) {
    return null;
  }

  let latestDate: Date | null = null;
  for (const date of dates) {
    const newDate = parseISO(date);
    if (latestDate === null) {
      latestDate = newDate;
    } else if (newDate !== null) {
      if (isAfter(newDate, latestDate)) {
        latestDate = newDate;
      }
    }
  }

  return latestDate;
};
